import React, { useEffect, useState } from 'react';
import { useNotionContext } from '../context';
import { Audio } from './audio';
import { PlaceholderComponent } from './placeholder-component';
export var ExternalComponentDropbox = function (_a) {
    var original_url = _a.original_url, block = _a.block;
    var components = useNotionContext().components;
    var url = new URL(original_url);
    var _b = useState(url.pathname.substring(1)), name = _b[0], setName = _b[1];
    var _c = useState(''), extension = _c[0], setExtension = _c[1];
    var _d = useState('0 Mb'), size = _d[0], setSize = _d[1];
    var _e = useState(''), uri = _e[0], setUri = _e[1];
    useEffect(function () {
        ;
        (block.format.attributes || []).forEach(function (att) {
            if (att.id == 'title') {
                setName(att.values[0]);
            }
            else if (att.id == 'extension') {
                setExtension(att.values[0]);
            }
            else if (att.id == 'file_size') {
                setSize(att.values[0]);
            }
        });
        var bUri = String(block.format.uri);
        if (bUri.indexOf('dl=0')) {
            bUri = bUri.replace('dl=0', 'dl=1');
        }
        else if (bUri.indexOf('?')) {
            bUri += '&dl=1';
        }
        else {
            bUri += '?dl=1';
        }
        setUri(bUri);
    }, []);
    var content = null;
    switch (extension) {
        case '.wav':
        case '.mp3':
        case '.acc': {
            content = React.createElement(Audio, { url: uri, block: block });
            break;
        }
        case '.pdf': {
            content = React.createElement(components.pdf, { file: uri });
            break;
        }
        default: {
            content = React.createElement(PlaceholderComponent, null);
        }
    }
    return (React.createElement(components.link, { target: '_blank', rel: 'noopener noreferrer', href: original_url, className: 'notion-external-dropbox' },
        content,
        React.createElement("div", { className: 'notion-external-information' },
            React.createElement("div", { className: 'notion-external-image' },
                React.createElement("img", { width: '33.744px', src: 'https://promostrat.notion.site/images/external_integrations/dropbox-icon.png', alt: '' })),
            React.createElement("div", { className: 'notion-external-description' },
                React.createElement("div", { className: 'notion-external-title' }, name),
                React.createElement("div", { className: 'notion-external-subtitle' }, size)))));
};
//# sourceMappingURL=external-component-dropbox.js.map